// extracted by mini-css-extract-plugin
module.exports = {"styledSyntaxHighlighter":"Tds9BZtm"};